jQuery(document).ready(($) => {
    $(".testimonials-list").slick({
        dots: false,
        arrows: true,
        centerMode: true,
        variableWidth: true,
        appendArrows: $(".slider-arrows-container"),
        prevArrow: '<button type="button" class="slick-prev"><i class="icon-arrow-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="icon-arrow-right"></i></button>',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    variableWidth: false,
                },
            },
        ],
    });
});
